import {StateParams} from 'angular-ui-router';
import {NavigationService} from "../../Services/NavigationService";
import {BookingDataService} from "../../Services/BookingDataService";
import {EStatus, ITimeBookingVm} from "../../Data/Data";

export class BookingListController {
  static controllerId = "BookingListController";
  static $inject = [
    "$scope",
    '$stateParams',
    NavigationService.serviceId,
    BookingDataService.serviceId,
  ];

  userId: number;
  loading = true;
  bookings: ITimeBookingVm[] = [];

  constructor(private $scope: ng.IScope,
              $stateParams: StateParams,
              private navigation: NavigationService,
              private bookingData: BookingDataService) {
    this.userId = $stateParams['userId'];
    this.reloadData();
  }

  goBack() {
    this.navigation.goToMenu();
  }

  reloadData() {
    this.loading = true;
    this.bookingData.browse(this.userId).then(bookings => {
      this.loading = false;
      this.bookings = bookings;
    });
  };

  openDetail(booking: any) {
    if (this.isBookingDisabled(booking)) return;
    this.navigation.goToState('booking-detail', {
      userId: this.userId,
      bookingId: booking ? booking.id : null,
    });
  }

  getStatusClass(booking: ITimeBookingVm) {
    if (booking.to === null) {
      return 'status-orange';
    } else if (booking.status === EStatus.Failed) {
      return 'status-red';
    } else if (booking.status === EStatus.Pending) {
      return 'status-yellow';
    } else {
      return 'status-green';
    }
  }

  isBookingDisabled(booking: ITimeBookingVm): boolean {
    return booking !== null && booking.to === null;
  }
}
